import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { IconChevronLeft, IconDeviceFloppy } from '@tabler/icons-react';

const MobileHeader = ({ 
  isEditing, 
  onCancel, 
  onSaveDraft, 
  draftLoading 
}) => {
  return (
    <div className="mpf-mobile-header d-md-none">
      <div className="mpf-mobile-header-content">
        <Button 
          variant="outline-secondary" 
          size="sm" 
          onClick={onCancel}
          className="mpf-back-btn"
        >
          <IconChevronLeft size={16} />
          Voltar
        </Button>
        
        <h1 className="mpf-mobile-title">
          {isEditing ? "Editar Publicação" : "Nova Publicação"}
        </h1>
        
        {!isEditing && (
          <Button
            variant="outline-primary"
            size="sm"
            onClick={onSaveDraft}
            disabled={draftLoading}
            className="mpf-save-draft-btn"
          >
            {draftLoading ? (
              <Spinner size="sm" />
            ) : (
              <IconDeviceFloppy size={16} />
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default MobileHeader;